import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { inject, observer, PropTypes as MobXPropTypes } from 'mobx-react';
import { ROUTE_PATHS } from 'routes/constants';
import './Messages.scss';

const Messages = ({ userAccount, messagesStore }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    messagesStore.initializeData(userAccount?.account_number).then(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userAccount?.account_number]);

  useEffect(() => {
    if (id && messagesStore.isInitialized) {
      messagesStore.clearError();
      const topicIndex = messagesStore.getCurrentTopicIndexById(id);
      messagesStore.setCurrentTopicIndex(topicIndex);

      if (topicIndex === -1) {
        // Redirect to messages list instead of 404 when topic not found
        // This handles the case when switching between customers
        navigate(ROUTE_PATHS.MESSAGES);
      } else {
        // Reset messages pagination when switching topics
        messagesStore.resetMessagesPagination();

        if (messagesStore.topics[topicIndex].read === false) {
          messagesStore.markTopicAsRead(userAccount?.account_number, id, topicIndex);
        }
        messagesStore.getCurrentTopicMessages(userAccount?.account_number, id, 'latest');
      }
    } else {
      messagesStore.setCurrentTopicIndex(-1);
    }
  }, [location.pathname, messagesStore.isInitialized]);

  return (
    <section className={'page-container messages'}>
      <Outlet />
    </section>
  );
};

Messages.propTypes = {
  userAccount: MobXPropTypes.observableObject,
  messagesStore: MobXPropTypes.observableObject
};

export default inject((stores) => ({
  userAccount: stores.userStore.userData.account,
  messagesStore: stores.messagesStore
}))(observer(Messages));
